// import axios from "axios";
import React, { Component } from "react";
import { Bar } from 'react-chartjs-2';  
// import AppConfig from "../../../../../config/AppConfig";
class DiagramMhsAktif extends Component {
      options = {
        scales: {
            yAxes: [{
                ticks: {
                    beginAtZero: true,
                    userCallback: function(label, index, labels) {
                        // when the floored value is the same as the value we have a whole number
                        if (Math.floor(label) === label) {
                            return label;
                        }
   
                    },
                }
            }],
        },
    }
    state = {
        data : '',
        data2 : '',
        data3 : '',
    }
    
    // componentDidMount(){
    //     // console.log(this.state.datasets1[0].data);
    //     let userdata = JSON.parse(localStorage.getItem("userdata"));
    //     let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));  
        
    //     let session = "";
    //     if(userdata){
    //       session = 
    //       // "?token="+userdata.token+
    //       "?id_sp="+sessiondata.i_idunit
    //     }
    //     axios.get(AppConfig.MhsJenisPendaftaran + session)
    //     .then(res => {
    //       this.setState({
    //         data : res.data.result.data,
    //         data3 : res,
    //       })
    //     }).catch(err => {
    //       console.log(err);
    //     })
    //     axios.get(AppConfig.MhsTerdaftar + session)
    //     .then(res => {
    //       this.setState({
    //         data2 : res,
    //       })
    //     }).catch(err => {
    //       console.log(err);
    //     })
    //   }
    render(){
        let jumlah = this.props.dataMhs?.data_mhs_baru || {};
        // console.log("DATA MHS =", this.props.dataMhs.data_mhs_baru);
        // console.log("DATA MHS2 =", this.state.data2);
        let i =0;
        let year = [];
        let aktif = [];
        let p_didik_baru = [];
        let pindahan = [];
        let alih_jenjang = [];
        for(var key in jumlah){
            year[i] = key.substring(0,4) + "-" + key.substring(4, key.length);
            if(jumlah[key].aktif !== undefined){
                aktif[i] = jumlah[key].aktif;
            }else{
                aktif[i] = 0;
            }
            if(jumlah[key].peserta_didik_baru !== undefined){
                p_didik_baru[i] = jumlah[key].peserta_didik_baru;
            }else{
                p_didik_baru[i] = 0;
            }
            if(jumlah[key].pindahan !== undefined){
                pindahan[i] = jumlah[key].pindahan;
            }else{
                pindahan[i] = 0;
            }
            if(jumlah[key].alih_jenjang !== undefined){
                alih_jenjang[i]= jumlah[key].alih_jenjang;
            }else{
                alih_jenjang[i]= 0;
            }
            
            i++;
        }
        // console.log("LOPS =", year);
            let data = {
                labels: year,
                datasets: [
                {
                    type: 'bar',
                    label: 'Mahasiswa Aktif',
                    fill: false,
                    lineTension: 0.1,
                    backgroundColor: '#b6e3b9',
                    borderColor: '#b6e3b9',
                    borderCapStyle: 'butt',
                    borderDash: [],
                    borderDashOffset: 0.0,
                    borderJoinStyle: 'miter',
                    pointBorderColor: '#b6e3b9',
                    pointBackgroundColor: '#b6e3b9',
                    pointBorderWidth: 1,
                    pointHoverRadius: 5,
                    pointHoverBackgroundColor: '#b6e3b9',
                    pointHoverBorderColor: '#b6e3b9',
                    pointHoverBorderWidth: 2,
                    pointRadius: 1,
                    pointHitRadius: 10,
                    data: aktif
                },
                {
                type: 'bar',
                label: 'Peserta Didik Baru',
                fill: false,
                lineTension: 0.1,
                backgroundColor: '#7bc0f7',
                borderColor: '#7bc0f7',
                borderCapStyle: 'butt',
                borderDash: [],
                borderDashOffset: 0.0,
                borderJoinStyle: 'miter',
                pointBorderColor: '#7bc0f7',
                pointBackgroundColor: '#fff',
                pointBorderWidth: 1,
                pointHoverRadius: 5,
                pointHoverBackgroundColor: '#7bc0f7',
                pointHoverBorderColor: '#7bc0f7',
                pointHoverBorderWidth: 2,
                pointRadius: 1,
                pointHitRadius: 10,
                data: p_didik_baru
            },
            {
            type: 'bar',
            label: 'Mahasiswa Pindahan',
            fill: false,
            lineTension: 0.1,
            backgroundColor: '#ccb6e3',
            borderColor: '#ccb6e3',
            borderCapStyle: 'butt',
            borderDash: [],
            borderDashOffset: 0.0,
            borderJoinStyle: 'miter',
            pointBorderColor: '#ccb6e3',
            pointBackgroundColor: '#fff',
            pointBorderWidth: 1,
            pointHoverRadius: 5,
            pointHoverBackgroundColor: '#ccb6e3',
            pointHoverBorderColor: '#ccb6e3',
            pointHoverBorderWidth: 2,
            pointRadius: 1,
            pointHitRadius: 10,
            data: pindahan
            },
            
            {
                type: 'bar',
                label: 'Alih Program',
                fill: false,
                lineTension: 0.1,
                backgroundColor: '#ffdb69',
                borderColor: '#ffdb69',
                borderCapStyle: 'butt',
                borderDash: [],
                borderDashOffset: 0.0,
                borderJoinStyle: 'miter',
                pointBorderColor: '#ffdb69',
                pointBackgroundColor: '#fff',
                pointBorderWidth: 1,
                pointHoverRadius: 5,
                pointHoverBackgroundColor: '#ffdb69',
                pointHoverBorderColor: '#ffdb69',
                pointHoverBorderWidth: 2,
                pointRadius: 1,
                pointHitRadius: 10,
                data: alih_jenjang
            },
            ]
      }
        return(
            <>
            <div className={`card-custom`}>
                {/* Header */}
                <div className="card-header border-0" style={{textAlign:'center', paddingBottom: "0px"}}>
                    <h5 className="card-title font-weight-bolder " style={{color:'#354f7a'}}>
                        Jumlah mahasiswa baru berdasarkan jenis pendaftaran dan mahasiswa aktif per semester
                    </h5>
                </div>

                {/* Body */}
                <div className="card-body pt-2">
                    <Bar data={data} options={this.options} title="Jumlah mahasiswa baru berdasarkan jenis pendaftaran dan mahasiswa aktif per semester"/>
                </div>
            </div>
            </>
        )
    }
}
export default DiagramMhsAktif;